import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22a3a5d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-box xag-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "panel-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "极飞服务", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/avatar_hd_img_p80_normal.svg",
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "xag-flex-1" }
const _hoisted_7 = { class: "xag-flex-lr up-box" }
const _hoisted_8 = { class: "xag-flex-1" }
const _hoisted_9 = { class: "xag-flex-lr down-box" }
const _hoisted_10 = { class: "xag-flex-1" }
const _hoisted_11 = { class: "footer" }
const _hoisted_12 = { class: "panel-box" }
const _hoisted_13 = { class: "panel xag-flex-lr" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "订单号", -1))
const _hoisted_15 = { class: "panel xag-flex-lr" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "创建时间", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xag-page__footer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, { title: "订单详情" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(['status-icon', _ctx.payIconClass])
      }, null, 2),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.payStatusTxt), 1),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item xag-flex",
            key: i
          }, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.product_name), 1),
                _createElementVNode("div", null, _toDisplayString(item.price) + "元/天", 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.serial_number), 1),
                _createElementVNode("div", null, "×" + _toDisplayString(item.day), 1)
              ])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_11, "实付款：¥" + _toDisplayString(_ctx.allMoney), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", null, _toDisplayString(_ctx.orderNo), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", null, _toDisplayString(_ctx.createdTime), 1)
        ])
      ])
    ]),
    _hoisted_17
  ], 64))
}